// Ícones da navegação — SVG em traço, a herdar a cor de quem os usa.
//
// Emoji seria mais rápido (o resto da app usa-os nos widgets), mas na barra de
// baixo cada telemóvel desenharia o seu: tamanhos diferentes, cor própria, e
// nunca o dourado. Em traço, o ícone acende a ouro quando está no meio e
// apaga-se em tinta quando não está — que é precisamente o que a barra precisa.

type Props = { className?: string };

function Svg({ className, children }: Props & { children: React.ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className ?? "h-6 w-6"}
      aria-hidden
    >
      {children}
    </svg>
  );
}

/** Início — casa. */
export function IconeCasa(p: Props) {
  return (
    <Svg {...p}>
      <path d="M3 10.7 12 3.4l9 7.3" />
      <path d="M5.6 9.6v9.7a1.3 1.3 0 0 0 1.3 1.3h10.2a1.3 1.3 0 0 0 1.3-1.3V9.6" />
      <path d="M9.7 20.6v-5.3h4.6v5.3" />
    </Svg>
  );
}

/** O trilho — o marco espetado no caminho. */
export function IconeMarco(p: Props) {
  return (
    <Svg {...p}>
      <path d="M6.2 21V3.4" />
      <path d="M6.2 4.6h11.3l-2.3 3.5 2.3 3.5H6.2z" />
    </Svg>
  );
}

/** Álbum — fotografia. */
export function IconeFoto(p: Props) {
  return (
    <Svg {...p}>
      <rect x="3" y="4.4" width="18" height="15.2" rx="2.4" />
      <circle cx="8.6" cy="9.7" r="1.5" />
      <path d="M3.4 16.8 8.9 11.3l4.3 4.3 2.6-2.6 4.8 4.8" />
    </Svg>
  );
}

/** Mapa — o pino do lugar. */
export function IconePino(p: Props) {
  return (
    <Svg {...p}>
      <path d="M12 21.2s6.8-5.9 6.8-10.6a6.8 6.8 0 1 0-13.6 0C5.2 15.3 12 21.2 12 21.2z" />
      <circle cx="12" cy="10.3" r="2.5" />
    </Svg>
  );
}

/** Calendário. */
export function IconeCalendario(p: Props) {
  return (
    <Svg {...p}>
      <rect x="3.2" y="5" width="17.6" height="15.4" rx="2.4" />
      <path d="M3.2 9.8h17.6" />
      <path d="M8.3 3.2v3.6M15.7 3.2v3.6" />
      <circle cx="8.4" cy="14" r="1" fill="currentColor" stroke="none" />
      <circle cx="12" cy="14" r="1" fill="currentColor" stroke="none" />
    </Svg>
  );
}

/** Conto — o livro aberto. */
export function IconeLivro(p: Props) {
  return (
    <Svg {...p}>
      <path d="M12 7.6S9.9 5.4 3.8 5.4v12.4c6.1 0 8.2 2.1 8.2 2.1s2.1-2.1 8.2-2.1V5.4C14.1 5.4 12 7.6 12 7.6z" />
      <path d="M12 7.6v12.3" />
    </Svg>
  );
}

/** Mensagens — o coração do "para sempre". */
export function IconeCoracao(p: Props) {
  return (
    <Svg {...p}>
      <path d="M12 20.4 4.5 12.9a4.7 4.7 0 0 1 6.6-6.7l.9.9.9-.9a4.7 4.7 0 0 1 6.6 6.7z" />
    </Svg>
  );
}

/** Jogos — o comando. */
export function IconeComando(p: Props) {
  return (
    <Svg {...p}>
      <rect x="2.6" y="8.2" width="18.8" height="10" rx="4.6" />
      <path d="M7.1 11.4v3.6M5.3 13.2h3.6" />
      <circle cx="16.1" cy="12.4" r="1.05" fill="currentColor" stroke="none" />
      <circle cx="18.2" cy="14.6" r="1.05" fill="currentColor" stroke="none" />
    </Svg>
  );
}

/** Notificações — o sino. */
export function IconeSino(p: Props) {
  return (
    <Svg {...p}>
      <path d="M6.3 9.6a5.7 5.7 0 0 1 11.4 0c0 4 1.3 5.4 1.9 6a.7.7 0 0 1-.5 1.2H4.9a.7.7 0 0 1-.5-1.2c.6-.6 1.9-2 1.9-6" />
      <path d="M10.3 20.1a2 2 0 0 0 3.4 0" />
    </Svg>
  );
}

/** Definições — a roda dentada, simplificada a oito dentes. */
export function IconeRoda(p: Props) {
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="3.1" />
      <path d="M12 2.6v2.7M12 18.7v2.7M21.4 12h-2.7M5.3 12H2.6M18.6 5.4l-1.9 1.9M7.3 16.7l-1.9 1.9M18.6 18.6l-1.9-1.9M7.3 7.3 5.4 5.4" />
    </Svg>
  );
}

/** O menu da conta — três traços. */
export function IconeMenu(p: Props) {
  return (
    <Svg {...p}>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </Svg>
  );
}

/** Sair — a porta com a seta. */
export function IconeSair(p: Props) {
  return (
    <Svg {...p}>
      <path d="M14.5 4.2H6.4a1.6 1.6 0 0 0-1.6 1.6v12.4a1.6 1.6 0 0 0 1.6 1.6h8.1" />
      <path d="M16.4 8.4 20 12l-3.6 3.6M20 12h-9.6" />
    </Svg>
  );
}
